import React from 'react';

export const SOLUQR_LOGO_SRC = '/soluqr/icons/soluqr-logo.png';
export const SOLUQR_LOGO_192_SRC = '/soluqr/icons/soluqr-logo-192.png';

/**
 * Marca SoluQR (logo naranja oficial).
 * @param {'sm'|'md'|'lg'|'xl'} [size]
 */
export default function SoluQrLogo({
  size = 'md',
  className = '',
  rounded = true,
  alt = 'SoluQR',
}) {
  const px = size === 'sm' ? 28 : size === 'lg' ? 56 : size === 'xl' ? 88 : 40;
  return (
    <img
      src={SOLUQR_LOGO_SRC}
      alt={alt}
      width={px}
      height={px}
      decoding="async"
      className={[
        'object-contain shrink-0 shadow-sm',
        rounded ? 'rounded-xl' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    />
  );
}
